import type { IntlShape } from "@formatjs/intl";
import { Form, Select } from "antd";
import { getMaterialCategoryOptions } from "../materialsConstants.ts";

type CategorySelectorFormItemProps = {
  intl: IntlShape;
};

export const CategorySelectorFormItem = ({ intl }: CategorySelectorFormItemProps) => (
  <Form.Item name="category" label={intl.formatMessage({ id: "material_category" })}>
    <Select allowClear options={getMaterialCategoryOptions(intl)} />
  </Form.Item>
);
